/**
 * leadmanagement-teamshops — Root App.
 *
 * Phase 4 Plan 02 ergaenzt react-router-basiertes Sub-Routing:
 *  - Route "" (index) → Board
 *  - Route "settings" → SettingsPage (Mail-Vorlagen-Editor)
 *
 * Der BrowserRouter ist vom Core-Frontend bereitgestellt (core/frontend/src/App.tsx).
 * Phase 3 nutzt bereits useSearchParams — react-router-dom ist also vorhanden.
 * Wir verwenden nur <Routes> + <Route> innerhalb des Programm-Containers.
 *
 * Relative Link-Pfade ("" und "settings") sind relativ zur Programm-Subroute
 * /programme/leadmanagement-teamshops/.
 *
 * Nav-Links zeigen immer an welche View aktiv ist (useLocation-Match).
 */

import { Routes, Route, Link, useLocation, useParams } from 'react-router-dom';
import Board from './components/Board';
import SettingsPage from './pages/SettingsPage';
import DashboardPage from './pages/DashboardPage';

export default function App() {
  const location = useLocation();
  const { programmeId } = useParams<{ programmeId: string }>();
  const base = `/programme/${programmeId}`;

  const isSettings = location.pathname.endsWith('/settings');
  const isDashboard = location.pathname.endsWith('/dashboard');
  const isBoard = !isSettings && !isDashboard;

  const navLink = (active: boolean) =>
    active
      ? `inline-block px-3 py-1 text-sm font-semibold rounded bg-[#E9FF57] text-[#1A1A1A]`
      : `inline-block px-3 py-1 text-sm font-medium text-[#1A1A1A] hover:underline`;

  return (
    <div>
      <nav className="mb-4 flex gap-3 border-b border-[#DAD9D9] pb-2">
        <Link to={base} className={navLink(isBoard)}>
          Board
        </Link>
        <Link to={`${base}/dashboard`} className={navLink(isDashboard)}>
          Dashboard
        </Link>
        <Link to={`${base}/settings`} className={navLink(isSettings)}>
          Einstellungen
        </Link>
      </nav>

      <Routes>
        <Route index element={<Board />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Routes>
    </div>
  );
}
